import axios from 'axios';
import jwt from 'jsonwebtoken';
import { _zzyourmap_config } from './zz-yourmap-config';
// import { apiLib } from '../url-lib';


// const token = req.headers["authorization"]?.split(" ")[1];

let simulate = false;
let _temp_stored_token = null;
const config_solution = 'AXIOS';


export const _zzyourmap_authUtils = {};
export const _zzyourmap_ajax = {};
export const _zzyourmap_urlLib = {};


_zzyourmap_authUtils.getToken = () => {
  return _temp_stored_token;
};
_zzyourmap_authUtils.setToken = (token) => {
  _temp_stored_token = token;
  return _temp_stored_token;
};

// let token_value = 'Bearer ' + token;
// config.TOKEN_HEADER_KEY = 'X-AuthToken'; // name of the token in AJAX header (backend require 
// config.TOKEN_HEADER_KEY = 'Authorization'; // name of the token in AJAX header (backend require 
// 'Authorization' : 'Bearer ' + token,
// 'Authorization' : 'Bearer ' + _zzyourmap_authUtils.getToken(),

// `Content-Type: application/json; charset=utf-8`
/*
const CONTENT_TYPE_JSON = ajax_utils.CONTENT_TYPE_JSON; // 'application/json';
const initial_getmethod_headers_arr = [
  [key, value]
];
const initial_postmethod_headers_arr = [
  [key, value],
  ['Content-Type', CONTENT_TYPE_JSON]
];
const HEADER_KEY_CONTENT_TYPE = 'Content-Type';
*/
const CONTENT_TYPE_JSON = 'application/json';



// ---------- URL LIB
let local_config_url_prefix = 'http://localhost:9000';
if (window.location.host === "localhost:3000") {
  // stay default localhost backend API
} else if (window.location.host === "localhost:3001") {
  // stay default localhost backend API
} else if (window.location.host === "localhost:3002") {
  // stay default localhost backend API
} else {
  local_config_url_prefix = window.location.protocol + '//' + window.location.host;
}
_zzyourmap_urlLib.websitePrefix_set = (url) => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE SAJT
  // let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  local_config_url_prefix = url; //
  return url;
};


// http://localhost/projekti-gitphp/temp-ym-backend/
_zzyourmap_urlLib.websitePrefix = () => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE SAJT
  // let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  // let url = local_config_url_prefix; // moze da bude i 'http://mojsajt.com' kasnije
  // let url = 'http://localhost/projekti-gitphp/temp-ym-backend'; // moze da bude i 'http://mojsajt.com' kasnije
  let url = _zzyourmap_config.BACKEND_URL_PREFIX;
  return url;
};


// http://localhost/projekti-gitphp/temp-ym-backend/api-v1.php
_zzyourmap_urlLib.websiteApiPrefix = () => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE API
  // let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  // let url = local_config_url_prefix; // moze da bude i 'http://mojsajt.com' kasnije
  // let url = 'http://localhost/projekti-gitphp/temp-ym-backend'; // moze da bude i 'http://mojsajt.com' kasnije
  let url = _zzyourmap_config.BACKEND_URL_PREFIX;
  return url;
};


const _YM_API_ENDPOINT_PREFIX = _zzyourmap_config.BACKEND_API_ENDPOINT_PREFIX;


// 'http://localhost/projekti-gitphp/temp-ym-backend/temp-image-upload.php';
_zzyourmap_urlLib.test_404 = () => {
  //
  const endpoint = 'NONE_EXISTING';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint; // POST
  return url;
};


_zzyourmap_urlLib.create = (vr_tablename) => {
  //
  const endpoint = 'create';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&vr_tablename=' + vr_tablename; // POST
  return url;
};


_zzyourmap_urlLib.create_new_rev = (vr_tablename, of_id) => {
  //
  const endpoint = 'create_new_rev';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&vr_tablename=' + vr_tablename + '&of_id=' + of_id; // POST
  return url;
};


_zzyourmap_urlLib.master_update_flagdeleted = (of_id) => {
  //
  const endpoint = 'master_update_flagdeleted';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&of_id=' + of_id; // POST
  return url;
};
_zzyourmap_urlLib.master_update_undelete = (of_id) => {
  //
  const endpoint = 'master_update_undelete';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&of_id=' + of_id; // POST
  return url;
};


// '&x=' + Date.now();
const _couner_state = {
  counter: 0,
};
const _get_fresh_something = () => {
  // _couner_state.counter = _couner_state.counter + 1;
  // return ('f' + _couner_state.counter);
  return 'ft' + Date.now();
};


_zzyourmap_urlLib.get_all = () => {
  //
  const endpoint = 'get_all';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&f=' + _get_fresh_something(); // POST
  return url;
};

_zzyourmap_urlLib.image_lib_get_all = () => {
  //
  const endpoint = 'image_lib_get_all';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&f=' + _get_fresh_something(); // GET
  return url;
};

_zzyourmap_urlLib.image_library_upload_v1 = () => {
  // 'http://localhost/projekti-gitphp/temp-ym-backend/temp-image-upload.php';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + '/temp-image-upload.php'; // POST
  return url;
};

_zzyourmap_urlLib.image_library_upload_v3 = () => {
  // 'http://localhost/projekti-gitphp/temp-ym-backend/api-v1.php?endpoint=image_lib_upload';
  const endpoint = 'image_lib_upload';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint; // POST
  return url;
};

_zzyourmap_urlLib.image_lib_update_flagdeleted = (id) => {
  //
  const endpoint = 'image_lib_update_flagdeleted';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&id=' + id; // POST
  return url;
};

_zzyourmap_urlLib.image_lib_update_undelete = (id) => {
  //
  const endpoint = 'image_lib_update_undelete';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&id=' + id; // POST
  return url;
};

_zzyourmap_urlLib.image_lib_update_meta = (id) => {
  //
  const endpoint = 'image_lib_update_meta';
  let url = _zzyourmap_urlLib.websiteApiPrefix() + _YM_API_ENDPOINT_PREFIX + '?endpoint=' + endpoint + '&id=' + id; // POST
  return url;
};


// ---------- AJAX ADAPTER


//
_zzyourmap_ajax.get_all = async () => { // GET PUBLIC
  const simEndpoint = 'get_all';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.get_all();
    return axios.get(url, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

//
_zzyourmap_ajax.create = async (data, vr_tablename) => { // POST PUBLIC
  const simEndpoint = 'create';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.create(vr_tablename);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


//
_zzyourmap_ajax.create_new_rev = async (data, vr_tablename, of_id) => { // POST PUBLIC
  const simEndpoint = 'create_new_rev';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.create_new_rev(vr_tablename, of_id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

//
_zzyourmap_ajax.master_update_flagdeleted = async (data, of_id) => { // POST
  const simEndpoint = 'master_update_flagdeleted';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.master_update_flagdeleted(of_id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
//
_zzyourmap_ajax.master_update_undelete = async (data, of_id) => { // POST
  const simEndpoint = 'master_update_undelete';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.master_update_undelete(of_id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


// ----- image lib

//
_zzyourmap_ajax.image_lib_get_all = async () => { // GET PUBLIC
  const simEndpoint = 'get_all';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.image_lib_get_all();
    return axios.get(url, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

//
_zzyourmap_ajax.image_lib_update_flagdeleted = async (data, id) => { // POST
  const simEndpoint = 'image_lib_update_flagdeleted';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.image_lib_update_flagdeleted(id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
//
_zzyourmap_ajax.image_lib_update_undelete = async (data, id) => { // POST
  const simEndpoint = 'image_lib_update_undelete';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.image_lib_update_undelete(id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

//
_zzyourmap_ajax.image_lib_update_meta = async (data, id) => { // POST PUBLIC
  const simEndpoint = 'image_lib_update_meta';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzyourmap_urlLib.image_lib_update_meta(id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};




